// TODO: This needs to be called breakpoints or something
export default {
  MOBILE_LARGE: 425,
  MOBILE_MEDIUM: 375,
  MOBILE_SMALL: 320
};
